import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
// import axios from "axios";

import geoHKDistricts from "./data/geoJson/Hong_Kong_18_Districts.json";
import dataHKConsumerViewer from "./data/consumer_viewer_data_v7.json";
import dataDailyPatterns from "./data/daily_patterns.json";
import dataRecentTrends from "./data/recent_trends.json";

// import { data } from "./data/store_district_mockup_data";
// import useSwr from "swr";
import * as actions from "./store/actions/actions";
import Toolbar from "./layout/Toolbar/Toolbar";
import Content from "./layout/Content/Content";

import "./App.scss";

// const fetcher = (...args) => fetch(...args).then(res => res.json());

function App(props) {
  const [dataHKStores, setDataHKStores] = useState(null);
  const [dataHKDistricts, setDataHKDistricts] = useState(null);
  // const [dataHKCountry, setDataHKCountry] = useState(null);

  const dispatch = useDispatch();
  const currentPage = useSelector((state) => state.app.currentPage);

  /* * Fetch data using useSwr* */
  // const hkDist = useSwr(/*apiUrl*/, fetcher);
  // console.log("--useSwr:", hkDist.data, hkDist.error);

  const handleSetCurrentPage = (pageName) => {
    dispatch(actions.setCurrentPage(`${pageName}`));
  };

  useEffect(() => {
    /* * Initialization - fetch data from api * */
    //dispatch(actions.fetchData());
    dispatch(actions.fetchGeoDistricts(geoHKDistricts));
    // dispatch(actions.fetchDataHKConsumerViewer(dataHKConsumerViewer));
    dispatch(actions.fetchDailyPatterns(dataDailyPatterns));
    dispatch(actions.fetchRecentTrends(dataRecentTrends));
    return () => {};
  }, [dispatch]);

  useEffect(() => {
    if (dataHKConsumerViewer) {
      if (dataHKConsumerViewer["Analyze Stores"].length > 0) {
        const _dataHKStores = dataHKConsumerViewer["Analyze Stores"].map(
          (item) => ({
            ID: item.ID,
            NAME: item.Name,
            latitude: item.Latitude,
            longitude: item.Longitude,
            segment: item.Segment,
            // ...item["Consumer Demographics"],
            // ...item["Consumer Interest"],
            // ...item["Store Surrounding"],
            // ...item.Footfall,
            data: {
              ...item["Consumer Demographics"],
              ...item["Consumer Interest"],
              ...item["Store Surrounding"],
              ...item.Footfall,
            },
          })
        );
        setDataHKStores(_dataHKStores);
      }

      if (dataHKConsumerViewer["Analyze Districts"].length > 0) {
        const _dataHKDistricts = dataHKConsumerViewer["Analyze Districts"].map(
          (item) => ({
            ID: item.ID,
            NAME: item.Name,
            latitude: item.Latitude,
            longitude: item.Longitude,
            data: {
              ...item["Consumer Demographics"],
              ...item["Consumer Interest"],
              ...item["Store Surrounding"],
              ...item.Footfall,
            },
          })
        );
        setDataHKDistricts(_dataHKDistricts);
      }
    }
    return () => {};
  }, [dataHKConsumerViewer]);

  useEffect(() => {
    if (dataHKStores) {
      dispatch(actions.fetchDataHKStores(dataHKStores));
    }
    return () => {};
  }, [dataHKStores]);

  useEffect(() => {
    if (dataHKDistricts) {
      dispatch(actions.fetchDataHKDistricts(dataHKDistricts));
    }
    return () => {};
  }, [dataHKDistricts]);

  /*useEffect(() => {
    if (dataHKCountry) {
      dispatch(actions.fetchDataHKCountry(dataHKCountry));
    }
    return () => {};
  }, [dataHKCountry]);*/

  const toolbarProps = { currentPage, handleSetCurrentPage };
  const contentProps = { ...props, handleSetCurrentPage };
  // const reportsProps = { ...props, handleSetCurrentPage };

  return (
    <div className="app">
      <Router basename="/">
        <Toolbar {...toolbarProps} />
        <Content {...contentProps} />
      </Router>
    </div>
  );
}

const mapStateToProps = (state) => ({
  keplerGl: state.keplerGl,
  app: state.app,
  data: state.data,
  reports: state.reports,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(App);
